import { render, staticRenderFns } from "./AllocationChartProducts.vue?vue&type=template&id=58c2a5f6&scoped=true&"
import script from "./AllocationChartProducts.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AllocationChartProducts.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AllocationChartProducts.vue?vue&type=style&index=0&id=58c2a5f6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c2a5f6",
  null
  
)

export default component.exports